import { render, staticRenderFns } from "./profitExamine.vue?vue&type=template&id=168a63ba&scoped=true&"
import script from "./profitExamine.vue?vue&type=script&lang=js&"
export * from "./profitExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a63ba",
  null
  
)

export default component.exports